<template>
  <ValidationProvider :name="`'${$t('Каптча')}'`" :rules="{ required: !isTestMode }">
    <img :src="image" :title="$t('Обновить капчу')" @click="reloadImage">
    <validatable-text-input
        :value="captcha"
        rules="required"
        :label="$t('Капча')"
        prepend-icon="how_to_reg"
        @input="inputCaptcha" />
  </ValidationProvider>
</template>

<script>
  import ValidatableTextInput from './ValidatableTextInput.vue'
  import { mapActions, mapState } from 'vuex'
  import { CAPTCHA } from '@/constants/store.js'

  export default {
    components: {
      ValidatableTextInput
    },
    props: {
      captcha: {
        type: [String],
        default: null
      }
    },
    computed: {
      ...mapState(CAPTCHA.NAMESPACE, {
        image: state => (state[CAPTCHA.STATE.IMAGE])
      })
    },
    watch: {
      generalError: {
        immediate: true,
        handler (newVal) {
          if (newVal) {
            this.reloadImage()
          }
        }
      }
    },
    beforeDestroy () {
      this.clean()
    },
    created () {
      this.reloadImage()
    },
    methods: {
      ...mapActions(CAPTCHA.NAMESPACE, {
        getCaptchaImageAction: CAPTCHA.ACTIONS.GET_CAPTCHA_IMAGE,
        clearCaptchaImageAction: CAPTCHA.ACTIONS.CLEAR_CAPTCHA_IMAGE
      }),
      reloadImage: async function () {
        await this.getCaptchaImageAction()
        this.$emit('input', null)
      },
      clean () {
        this.clearCaptchaImageAction()
      },
      inputCaptcha (value) {
        this.$emit('input', value)
      }
    }
  }
</script>
